// Catchy proposing tracker changes (CatchyCard.jsx, 2026-10-30) — the card, the reminder setting, a record's history.
const en = {
  // grounded answers (what was looked up, ids not looked up) + why a card is allowed (Jay tasks #1113 / #1115, 31/10)
  lookedUp: "Looked up",
  unverified: "Not looked up in the Portal — do not act on these without checking:",
  why_admin: "You can make this change because you are an Admin.",
  why_owner: "You can make this change because you own the project.",
  why_team_manager: "You can make this change because you manage the project's Sales OP team.",
  why_developer: "You can make this change because you are the SKU's developer.",
  why_designer: "You can make this change because you are the SKU's designer.",
  why_sku_team: "You can make this change because your team edits the SKU part of every project.",
  why_open: "Anyone who edits Project Tracker can make this change — the SKU has no project owner or team.",
  // what blocked an answer + report to admin (GapReport.jsx, Max 31/10)
  gap_permission: "Held back from Catchy",
  gap_data: "Not in the Portal",
  gap_tool: "Catchy has no way to read this yet",
  gap_rule: "Catchy needs the company rule for this",
  gapReport: "Report to admin",
  gapNotePh: "What did you need? (optional)",
  gapSend: "Send",
  gapSent: "Sent — it is in today's 16:00 report to the admin",
  willCreate: "Catchy will create",
  willChange: "Catchy will change",
  field: "Field",
  now: "Now",
  value: "Value",
  notSaved: "Nothing is saved until you confirm.",
  cancel: "Cancel",
  confirm: "Confirm",
  saving: "Saving…",
  applied: "Saved —",
  cancelled: "Cancelled — nothing was saved.",
  stale: "Not saved — the record changed since this card was made. Ask Catchy again.",
  failed: "Not saved — the tracker refused it.",
  yes: "Yes",
  no: "No",
  prefSaved: "Saved.",
  nothingToRemind: "Nothing of yours is waiting for an update right now.",
  remind: "Catchy reminders:",
  n_daily: "every working day",
  n_2days: "every 2 days",
  n_weekly: "every Monday",
  n_off: "off",
  days: "{{n}} days",
  staleOpt: "after {{n}} days without an update",
  preview: "show me today's",
  close: "Close",
  historyOf: "History of {{id}}",
  loading: "Loading…",
  noHistory: "No changes recorded yet.",
  viaScreen: "Portal screen",
  viaSystem: "System",
  openChat: "open the chat",
  history: "History",
  startedByCatchy: "Catchy wrote first",
  after: "After",
  // a lookup that failed or came back cut (Jay #1113, 31/10)
  lookupsIncomplete: "Not complete — {{list}}. The answer may miss items.",
  lkFailed: "the lookup failed",
  lkCut: "only {{note}}",
  deepBtn: "Deeper analysis",
  deepTag: "Deeper analysis",
  deepWarn: "This asks the same question again on a stronger model. It takes longer and costs more (about USD 0.30–1.00), counted in your own daily AI budget.",
  deepLeft: "You have {{n}} of {{limit}} left today.",
  deepAdmin: "Admin: no daily limit.",
  deepRun: "Run it",
  deepCancel: "Cancel",
};
const ko = {
  // grounded answers (what was looked up, ids not looked up) + why a card is allowed (Jay tasks #1113 / #1115, 31/10)
  lookedUp: "조회한 화면",
  unverified: "포털에서 조회하지 않은 항목 — 확인 전에는 사용하지 마세요:",
  why_admin: "Admin이라서 이 변경을 할 수 있습니다.",
  why_owner: "프로젝트 오너라서 이 변경을 할 수 있습니다.",
  why_team_manager: "프로젝트의 Sales OP 팀 매니저라서 이 변경을 할 수 있습니다.",
  why_developer: "이 SKU의 개발 담당이라서 이 변경을 할 수 있습니다.",
  why_designer: "이 SKU의 디자이너라서 이 변경을 할 수 있습니다.",
  why_sku_team: "소속 팀이 모든 프로젝트의 SKU 정보를 수정하는 팀이라서 이 변경을 할 수 있습니다.",
  why_open: "이 SKU에는 프로젝트 오너나 팀이 없어서 Project Tracker 편집 권한이 있으면 누구나 변경할 수 있습니다.",
  // what blocked an answer + report to admin (GapReport.jsx, Max 31/10)
  gap_permission: "Catchy에게 공개되지 않은 정보",
  gap_data: "포털에 없는 정보",
  gap_tool: "Catchy가 아직 읽을 수 없는 정보",
  gap_rule: "회사 기준이 필요한 질문",
  gapReport: "관리자에게 보고",
  gapNotePh: "무엇이 필요했나요? (선택)",
  gapSend: "보내기",
  gapSent: "보냈습니다 — 오늘 16:00 관리자 보고서에 포함됩니다",
  willCreate: "Catchy가 만들 내용",
  willChange: "Catchy가 바꿀 내용",
  field: "항목",
  now: "현재",
  value: "값",
  notSaved: "확인하기 전에는 저장되지 않습니다.",
  cancel: "취소",
  confirm: "확인",
  saving: "저장 중…",
  applied: "저장됨 —",
  cancelled: "취소됨 — 저장되지 않았습니다.",
  stale: "저장 안 됨 — 카드가 만들어진 뒤 기록이 바뀌었습니다. Catchy에게 다시 요청하세요.",
  failed: "저장 안 됨 — 트래커가 거부했습니다.",
  yes: "예",
  no: "아니요",
  prefSaved: "저장했습니다.",
  nothingToRemind: "지금 업데이트를 기다리는 항목이 없습니다.",
  remind: "Catchy 알림:",
  n_daily: "매 근무일",
  n_2days: "2일마다",
  n_weekly: "매주 월요일",
  n_off: "끔",
  days: "{{n}}일",
  staleOpt: "{{n}}일 동안 업데이트가 없으면",
  preview: "오늘 메시지 보기",
  close: "닫기",
  historyOf: "{{id}} 기록",
  loading: "불러오는 중…",
  noHistory: "기록된 변경이 없습니다.",
  viaScreen: "포털 화면",
  viaSystem: "시스템",
  openChat: "채팅 열기",
  history: "기록",
  startedByCatchy: "Catchy가 먼저 보냄",
  after: "변경 후",
  // a lookup that failed or came back cut (Jay #1113, 31/10)
  lookupsIncomplete: "일부만 조회됨 — {{list}}. 답변에 빠진 항목이 있을 수 있습니다.",
  lkFailed: "조회 실패",
  lkCut: "{{note}}만 조회",
  deepBtn: "심층 분석",
  deepTag: "심층 분석",
  deepWarn: "같은 질문을 더 강력한 모델로 다시 묻습니다. 시간이 더 걸리고 비용도 더 듭니다(약 USD 0.30–1.00). 개인 일일 AI 예산에서 차감됩니다.",
  deepLeft: "오늘 {{limit}}회 중 {{n}}회 남았습니다.",
  deepAdmin: "관리자: 일일 제한 없음.",
  deepRun: "실행",
  deepCancel: "취소",
};
const vi = {
  // grounded answers (what was looked up, ids not looked up) + why a card is allowed (Jay tasks #1113 / #1115, 31/10)
  lookedUp: "Đã tra",
  unverified: "Chưa tra trong Portal — đừng dùng những mã này khi chưa kiểm:",
  why_admin: "Bạn sửa được vì bạn là Admin.",
  why_owner: "Bạn sửa được vì bạn là owner của dự án.",
  why_team_manager: "Bạn sửa được vì bạn là manager của team Sales OP phụ trách dự án.",
  why_developer: "Bạn sửa được vì bạn là developer của SKU này.",
  why_designer: "Bạn sửa được vì bạn là designer của SKU này.",
  why_sku_team: "Bạn sửa được vì team của bạn được sửa phần SKU của mọi dự án.",
  why_open: "SKU này chưa có owner hay team, nên ai có quyền sửa Project Tracker cũng sửa được.",
  // what blocked an answer + report to admin (GapReport.jsx, Max 31/10)
  gap_permission: "Catchy chưa được xem thông tin này",
  gap_data: "Portal chưa có dữ liệu này",
  gap_tool: "Catchy chưa có cách đọc phần này",
  gap_rule: "Catchy cần luật của công ty cho câu này",
  gapReport: "Báo cho admin",
  gapNotePh: "Bạn cần gì? (không bắt buộc)",
  gapSend: "Gửi",
  gapSent: "Đã gửi — có trong báo cáo 16:00 hôm nay gửi admin",
  willCreate: "Catchy sẽ tạo",
  willChange: "Catchy sẽ thay đổi",
  field: "Trường",
  now: "Hiện tại",
  value: "Giá trị",
  notSaved: "Chưa lưu gì cho đến khi bạn xác nhận.",
  cancel: "Huỷ",
  confirm: "Xác nhận",
  saving: "Đang lưu…",
  applied: "Đã lưu —",
  cancelled: "Đã huỷ — không có gì được lưu.",
  stale: "Chưa lưu — record đã bị đổi sau khi thẻ này được tạo. Hỏi lại Catchy nhé.",
  failed: "Chưa lưu — tracker từ chối thay đổi.",
  yes: "Có",
  no: "Không",
  prefSaved: "Đã lưu.",
  nothingToRemind: "Hiện không có việc nào của bạn đang chờ cập nhật.",
  remind: "Catchy nhắc việc:",
  n_daily: "mỗi ngày làm việc",
  n_2days: "2 ngày một lần",
  n_weekly: "mỗi thứ Hai",
  n_off: "tắt",
  days: "{{n}} ngày",
  staleOpt: "sau {{n}} ngày không cập nhật",
  preview: "xem tin hôm nay",
  close: "Đóng",
  historyOf: "Lịch sử của {{id}}",
  loading: "Đang tải…",
  noHistory: "Chưa có thay đổi nào được ghi.",
  viaScreen: "Màn hình portal",
  viaSystem: "Hệ thống",
  openChat: "mở đoạn chat",
  history: "Lịch sử",
  startedByCatchy: "Catchy nhắn trước",
  after: "Sau khi đổi",
  // a lookup that failed or came back cut (Jay #1113, 31/10)
  lookupsIncomplete: "Chưa tra đủ — {{list}}. Câu trả lời có thể thiếu mục.",
  lkFailed: "lần tra bị lỗi",
  lkCut: "chỉ {{note}}",
  deepBtn: "Phân tích sâu hơn",
  deepTag: "Phân tích sâu hơn",
  deepWarn: "Câu hỏi này sẽ được hỏi lại bằng model mạnh hơn. Mất thời gian hơn và tốn hơn (khoảng USD 0,30–1,00), tính vào hạn mức AI trong ngày của bạn.",
  deepLeft: "Hôm nay bạn còn {{n}} / {{limit}} lượt.",
  deepAdmin: "Admin: không giới hạn trong ngày.",
  deepRun: "Chạy",
  deepCancel: "Huỷ",
};
const zh = {
  // grounded answers (what was looked up, ids not looked up) + why a card is allowed (Jay tasks #1113 / #1115, 31/10)
  lookedUp: "已查询",
  unverified: "未在门户中查询 — 核实前请勿据此操作：",
  why_admin: "您是 Admin，因此可以进行此修改。",
  why_owner: "您是项目负责人，因此可以进行此修改。",
  why_team_manager: "您是该项目 Sales OP 团队的经理，因此可以进行此修改。",
  why_developer: "您是该 SKU 的开发负责人，因此可以进行此修改。",
  why_designer: "您是该 SKU 的设计师，因此可以进行此修改。",
  why_sku_team: "您的团队可以修改所有项目的 SKU 部分，因此可以进行此修改。",
  why_open: "该 SKU 没有项目负责人或团队，任何有 Project Tracker 编辑权限的人都可以修改。",
  // what blocked an answer + report to admin (GapReport.jsx, Max 31/10)
  gap_permission: "该信息未向 Catchy 开放",
  gap_data: "门户中没有该数据",
  gap_tool: "Catchy 暂时无法读取这部分",
  gap_rule: "Catchy 需要公司的相关规则",
  gapReport: "报告给管理员",
  gapNotePh: "您需要什么？（可选）",
  gapSend: "发送",
  gapSent: "已发送 — 将包含在今天 16:00 给管理员的报告中",
  willCreate: "Catchy 将创建",
  willChange: "Catchy 将更改",
  field: "字段",
  now: "当前",
  value: "值",
  notSaved: "确认之前不会保存任何内容。",
  cancel: "取消",
  confirm: "确认",
  saving: "保存中…",
  applied: "已保存 —",
  cancelled: "已取消 — 未保存任何内容。",
  stale: "未保存 — 卡片生成后记录已被更改。请重新询问 Catchy。",
  failed: "未保存 — 跟踪器拒绝了此更改。",
  yes: "是",
  no: "否",
  prefSaved: "已保存。",
  nothingToRemind: "目前没有等待更新的项目。",
  remind: "Catchy 提醒：",
  n_daily: "每个工作日",
  n_2days: "每 2 天",
  n_weekly: "每周一",
  n_off: "关闭",
  days: "{{n}} 天",
  staleOpt: "{{n}} 天未更新时",
  preview: "查看今天的消息",
  close: "关闭",
  historyOf: "{{id}} 的记录",
  loading: "加载中…",
  noHistory: "尚无更改记录。",
  viaScreen: "门户页面",
  viaSystem: "系统",
  openChat: "打开对话",
  history: "记录",
  startedByCatchy: "Catchy 先发起",
  after: "更改后",
  // a lookup that failed or came back cut (Jay #1113, 31/10)
  lookupsIncomplete: "查询不完整 — {{list}}。回答可能遗漏条目。",
  lkFailed: "查询失败",
  lkCut: "仅 {{note}}",
  deepBtn: "深入分析",
  deepTag: "深入分析",
  deepWarn: "将用更强的模型重新回答同一个问题。耗时更长、费用更高（约 USD 0.30–1.00），计入你个人的每日 AI 预算。",
  deepLeft: "今天还剩 {{n}} / {{limit}} 次。",
  deepAdmin: "管理员：无每日限制。",
  deepRun: "运行",
  deepCancel: "取消",
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "lookedUp": "Consulté",
  "unverified": "Non vérifié dans le portail — ne pas agir sans vérification :",
  "why_admin": "Vous pouvez effectuer cette modification car vous êtes Admin.",
  "why_owner": "Vous pouvez effectuer cette modification car vous êtes propriétaire du projet.",
  "why_team_manager": "Vous pouvez effectuer cette modification car vous gérez l'équipe Sales OP du projet.",
  "why_developer": "Vous pouvez effectuer cette modification car vous êtes le developer du SKU.",
  "why_designer": "Vous pouvez effectuer cette modification car vous êtes le designer du SKU.",
  "why_sku_team": "Vous pouvez effectuer cette modification car votre équipe modifie la partie SKU de chaque projet.",
  "why_open": "Toute personne qui modifie Project Tracker peut effectuer cette modification — le SKU n'a ni propriétaire de projet ni équipe.",
  "gap_permission": "Non accessible à Catchy",
  "gap_data": "Absent du portail",
  "gap_tool": "Catchy ne peut pas encore lire cela",
  "gap_rule": "Catchy a besoin de la règle de l'entreprise pour cela",
  "gapReport": "Signaler à l'admin",
  "gapNotePh": "De quoi aviez-vous besoin ? (facultatif)",
  "gapSend": "Envoyer",
  "gapSent": "Envoyé — figure dans le rapport de 16:00 d'aujourd'hui à l'admin",
  "willCreate": "Catchy va créer",
  "willChange": "Catchy va modifier",
  "field": "Champ",
  "now": "Actuel",
  "value": "Valeur",
  "notSaved": "Rien n'est enregistré tant que vous n'avez pas confirmé.",
  "cancel": "Annuler",
  "confirm": "Confirmer",
  "saving": "Enregistrement…",
  "applied": "Enregistré —",
  "cancelled": "Annulé — rien n'a été enregistré.",
  "stale": "Non enregistré — l'enregistrement a changé depuis la création de cette carte. Redemandez à Catchy.",
  "failed": "Non enregistré — le tracker l'a refusé.",
  "yes": "Oui",
  "no": "Non",
  "prefSaved": "Enregistré.",
  "nothingToRemind": "Rien de votre part n'attend de mise à jour pour l'instant.",
  "remind": "Rappels de Catchy :",
  "n_daily": "chaque jour ouvré",
  "n_2days": "tous les 2 jours",
  "n_weekly": "chaque lundi",
  "n_off": "désactivé",
  "days": "{{n}} jours",
  "staleOpt": "après {{n}} jours sans mise à jour",
  "preview": "afficher ceux d'aujourd'hui",
  "close": "Fermer",
  "historyOf": "Historique de {{id}}",
  "loading": "Chargement…",
  "noHistory": "Aucune modification enregistrée pour l'instant.",
  "viaScreen": "Écran du portail",
  "viaSystem": "Système",
  "openChat": "ouvrir le chat",
  "history": "Historique",
  "startedByCatchy": "Catchy a écrit en premier",
  "after": "Après",
  "lookupsIncomplete": "Incomplet — {{list}}. La réponse peut omettre des éléments.",
  "lkFailed": "la recherche a échoué",
  "lkCut": "seulement {{note}}",
  "deepBtn": "Analyse approfondie",
  "deepTag": "Analyse approfondie",
  "deepWarn": "Cela repose la même question à un modèle plus puissant. C'est plus long et plus coûteux (environ USD 0.30–1.00), décompté de votre propre budget IA quotidien.",
  "deepLeft": "Il vous en reste {{n}} sur {{limit}} aujourd'hui.",
  "deepAdmin": "Admin : pas de limite quotidienne.",
  "deepRun": "Lancer",
  "deepCancel": "Annuler"
};
const ja = {
  "lookedUp": "検索済み",
  "unverified": "ポータルで確認していません — 確認せずに操作しないでください：",
  "why_admin": "あなたは Admin のため、この変更を行えます。",
  "why_owner": "あなたはプロジェクトのオーナーのため、この変更を行えます。",
  "why_team_manager": "あなたはプロジェクトの Sales OP チームを管理しているため、この変更を行えます。",
  "why_developer": "あなたは SKU のデベロッパーのため、この変更を行えます。",
  "why_designer": "あなたは SKU のデザイナーのため、この変更を行えます。",
  "why_sku_team": "あなたのチームがすべてのプロジェクトの SKU 部分を編集するため、この変更を行えます。",
  "why_open": "Project Tracker を編集できる人なら誰でもこの変更を行えます — この SKU にはプロジェクトオーナーもチームもありません。",
  "gap_permission": "Catchy には公開されていません",
  "gap_data": "ポータルにありません",
  "gap_tool": "Catchy はまだこれを読み取れません",
  "gap_rule": "Catchy にはこれに関する社内ルールが必要です",
  "gapReport": "管理者に報告",
  "gapNotePh": "必要だった内容は何ですか？（任意）",
  "gapSend": "送信",
  "gapSent": "送信しました — 本日 16:00 の管理者向けレポートに含まれます",
  "willCreate": "Catchy が作成します",
  "willChange": "Catchy が変更します",
  "field": "項目",
  "now": "現在",
  "value": "値",
  "notSaved": "確認するまで何も保存されません。",
  "cancel": "キャンセル",
  "confirm": "確認",
  "saving": "保存中…",
  "applied": "保存しました —",
  "cancelled": "キャンセルしました — 何も保存されていません。",
  "stale": "保存されていません — このカードの作成後にレコードが変更されました。もう一度 Catchy に依頼してください。",
  "failed": "保存されていません — トラッカーが受け付けませんでした。",
  "yes": "はい",
  "no": "いいえ",
  "prefSaved": "保存しました。",
  "nothingToRemind": "現在、更新待ちの項目はありません。",
  "remind": "Catchy のリマインダー：",
  "n_daily": "毎営業日",
  "n_2days": "2 日ごと",
  "n_weekly": "毎週月曜",
  "n_off": "オフ",
  "days": "{{n}} 日",
  "staleOpt": "更新がないまま {{n}} 日後",
  "preview": "本日分を表示",
  "close": "閉じる",
  "historyOf": "{{id}} の履歴",
  "loading": "読み込み中…",
  "noHistory": "記録された変更はまだありません。",
  "viaScreen": "ポータル画面",
  "viaSystem": "システム",
  "openChat": "チャットを開く",
  "history": "履歴",
  "startedByCatchy": "Catchy が先に入力",
  "after": "変更後",
  "lookupsIncomplete": "未完了 — {{list}}。回答に漏れがある可能性があります。",
  "lkFailed": "検索に失敗しました",
  "lkCut": "{{note}} のみ",
  "deepBtn": "詳細分析",
  "deepTag": "詳細分析",
  "deepWarn": "同じ質問を、より高性能なモデルで再度行います。時間がかかり、費用も増えます（約 USD 0.30–1.00）。ご自身の 1 日の AI 予算から差し引かれます。",
  "deepLeft": "本日の残りは {{limit}} 回中 {{n}} 回です。",
  "deepAdmin": "Admin：1 日の上限はありません。",
  "deepRun": "実行",
  "deepCancel": "キャンセル"
};

const dictionary = { ns: 'xCatchy', en, ko, vi, zh, fr, ja };

export default dictionary;
